import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { staffDirectoryRoute } from '@townsquare/routes/staff-directory-view';
import { teamsAppForYouAGGResource } from '@townsquare/teams-app-for-you-view/agg-resource';
import { teamsAppForYouWatermelonResource } from '@townsquare/teams-app-for-you-view/watermelon-resource';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { staffDirectoryResource } from './resources/staff-directory';

// Staff Directory View
const StaffDirectoryLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "RelayStaffDirectory" */ './components/StaffDirectoryView'),
	loading: () => null, // DirectorySkeleton, - TODO need to redo the skeleton, in its current form it will blow up our main bundle size
	delay: 0,
});

staffDirectoryRoute.component = StaffDirectoryLoadable;
staffDirectoryRoute.resources = [
	onboardingResource,
	staffDirectoryResource,
	tqlExplainerResource,
	teamsAppForYouAGGResource,
	teamsAppForYouWatermelonResource,
];
export const staffDirectoryRouterRoute = staffDirectoryRoute;
